import BaseService from './BaseService';

export default class SettingsService extends BaseService {
  // 获取公众号详细信息
  async getAccountDetails(data) {
    const url = this.API.settings.getAccountDetails;
    const result = await this.get(url, data);
    return result;
  }

  // 更新公众号
  async updateAccount(data) {
    const url = this.API.settings.updateAccount;
    const result = await this.post(url, data);
    return result;
  }

  // 绑定公众号
  async bindAccount(data) {
    const url = this.API.settings.bindAccount;
    const result = await this.post(url, data);
    return result;
  }

  // 获取菜单信息
  async getMenu(data) {
    const url = this.API.settings.getMenu;
    const result = await this.post(url, data);
    return result;
  }

  // 发布自定义菜单
  async menuPublish(data) {
    const url = this.API.settings.menuPublish;
    const result = await this.jsonPost(url, data);
    return result;
  }

  // 保存自定义菜单
  async menuSave(data) {
    const url = this.API.settings.menuSave;
    const result = await this.jsonPost(url, data);
    return result;
  }

  // 从微信平台同步菜单信息

}



// WEBPACK FOOTER //
// ./src/service/services/GoodsService.js